import { z } from 'zod'

export const loginSchema = z.object({
  username: z
    .string()
    .trim()
    .min(1, 'auth-common:form.errors.required')
    .refine(val => !val.includes('@') || z.email().safeParse(val).success, {
      message: 'auth-common:form.errors.email_invalid',
    }),
  password: z.string().trim().min(1, 'auth-common:form.errors.required'),
  remember: z.boolean(),
})

export type LoginFormValues = z.infer<typeof loginSchema>
